export default __webpack_public_path__ + "static/loyall-featured-image-design-light-612d52fc057910c0d9a7a5bbc2d4b682.jpg";